import Link from 'next/link';
import { ReactElement, useState } from 'react';

export type ToursCardProps = {
    href: string;
    imageSrc?: string;
    title: string;
    count?: number;
    countLabel?: string;
};

export const ToursCard = ({
    href,
    imageSrc,
    title,
    count,
    countLabel = 'tours',
}: ToursCardProps): ReactElement => {
    const [showFallback, setShowFallback] = useState(!imageSrc);

    return (
        <Link href={href} passHref>
            <a className="group relative block min-h-60 w-[min(67vw,360px)] shrink-0 snap-start overflow-hidden rounded-2xl shadow-lg transition duration-200 hover:-translate-y-0.5 hover:shadow-xl sm:w-auto sm:shrink">
                {showFallback ? (
                    <span
                        aria-hidden="true"
                        className="absolute inset-0 bg-cover bg-center bg-[url('/images/EmptyImg_mobile.png')] dark:bg-[url('/images/EmptyImg_mobile_dark.png')] md:bg-[url('/images/EmptyImg_ipad.png')] md:dark:bg-[url('/images/EmptyImg_ipad_dark.png')]"
                    />
                ) : (
                    <img
                        src={imageSrc}
                        alt=""
                        aria-hidden="true"
                        className="absolute inset-0 h-full w-full object-cover"
                        loading="lazy"
                        onError={() => setShowFallback(true)}
                    />
                )}
                <span className="absolute inset-0 bg-linear-to-t from-black/60 via-black/10 to-transparent" />
                <span className="relative flex h-full min-h-60 flex-col justify-end p-5">
                    <span className="tx-heading-4 line-clamp-2 text-white-normal transition-colors group-hover:text-white">
                        {title}
                    </span>
                    {typeof count === 'number' && (
                        <span className="tx-medium-medium mt-1 text-white-normal/85 bg-green-normal w-fit rounded-2xl px-6">
                            {count} {countLabel}
                        </span>
                    )}
                </span>
            </a>
        </Link>
    );
};

export default ToursCard;
